import Eyebrow from '@Guidelines/Component/Eyebrow';
import SubjectTypeTile from '@Guidelines/Component/SubjectTypeTile';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const previewStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

const tileRowStyle = css`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	color: ${theme.colors.ink};
`;

type Props = { icon: string; color: string; name: string };

/** The tile of the chosen icon and color next to the plural name, as the home page shows them. */
const AppearancePreview: React.FC<Props> = ({ icon, color, name }) => {
	return (
		<div css={previewStyle}>
			<Eyebrow>Aperçu</Eyebrow>
			<div css={tileRowStyle}>
				<SubjectTypeTile icon={icon} color={color} />
				<span>{name.trim().length > 0 ? name : 'Nom du type'}</span>
			</div>
		</div>
	);
};

export default AppearancePreview;
